import Request from "./request";

const axiosConvert = new Request(process.env.VUE_APP_API_CONVERT);
const axiosPassport = new Request(process.env.VUE_APP_API_PASSPORT);
const axiosMember = new Request(process.env.VUE_APP_API_MEMBER);
const axiosApiPassport = new Request(process.env.VUE_APP_API_SMS);

export { axiosConvert, axiosPassport, axiosMember, axiosApiPassport };
